module.exports = __webpack_public_path__ + "media/components/Influencers/Shared/SocialNetworkIcon/youtube-7ef44e3fc6c81d86e055e3dc6f52a1b2.png";